import { render, staticRenderFns } from "./BaseTabsTab.vue?vue&type=template&id=23a5951e&scoped=true&"
import script from "./BaseTabsTab.vue?vue&type=script&lang=js&"
export * from "./BaseTabsTab.vue?vue&type=script&lang=js&"
import style0 from "./BaseTabsTab.vue?vue&type=style&index=0&id=23a5951e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a5951e",
  null
  
)

export default component.exports